<div
    class="tw-py-[50px] tw-px-[28px] md:tw-px-[50px] lg:tw-px-[80px] tw-bg-[#024B3F0D]"
>
    <div
        class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-gap-[100px] md:tw-gap-[40px] tw-gap-[20px] tw-w-fit tw-mx-auto tw-items-stretch"
    >
        <!-- Loop through response "cards" -->
        <div
            *ngFor="let col of cards; trackBy: trackByColumn"
            class="lg:tw-w-[450px] md:tw-w-[331px] tw-flex tw-flex-col tw-gap-[32px] tw-h-full"
        >
            <!-- Header -->
            <div
                class="tw-bg-white tw-py-[18px] lg:tw-px-[24px] md:tw-px-[18px] tw-px-[24px] tw-rounded-[10px] tw-flex tw-flex-row tw-justify-between tw-flex-shrink-0"
            >
                <span
                    class="tw-text-[16px] tw-text-black tw-font-semibold tw-opacity-70"
                    >{{ col.title }}</span
                >
            </div>

            <!-- Child cards container for tablet and desktop -->
            <div
                class="tw-flex-col tw-gap-[32px] tw-flex-grow tw-hidden md:tw-flex"
            >
                <app-comp-cards
                    *ngFor="
                        let card of col.childElements
                            | slice : 0 : visibleCountPerColumn;
                        trackBy: trackByCard
                    "
                    [image]="card.imagedesktop || card?.logo_url"
                    [gaPrefix]="gaPrefix"
                    [title]="card.institution"
                    [subtitle]="card.title"
                    [description]="card.description"
                    [buttonText]="card.cta"
                    [url]="card.url"
                    (buttonClick)="openLink(card.url)"
                ></app-comp-cards>
            </div>

            <!-- Child cards container for mobile -->
            <div
                class="tw-flex-col tw-gap-[32px] tw-flex-grow tw-flex md:tw-hidden"
            >
                <app-card-type-4
                    [gaPrefix]="gaPrefix"
                    *ngFor="
                        let card of col.childElements
                            | slice : 0 : visibleCountPerColumn;
                        trackBy: trackByCard
                    "
                    [image]="card.imagedesktop || card?.logo_url"
                    [title]="card.institution"
                    [subtitle]="card.title"
                    [description]="card.description"
                    [buttonText]="card.cta"
                    (buttonClick)="openLink(card.url)"
                ></app-card-type-4>
            </div>
        </div>
    </div>

    <!-- Show More Button -->
    <div
        class="tw-flex tw-justify-center tw-mt-8"
        *ngIf="shouldShowMoreButton()"
    >
        <button
            [attr.ga-event-id]="
                'training_programmes_show_more_button_jc3_click'
            "
            [attr.ga-event-category]="'JC3 Button'"
            [attr.ga-event-label]="
                'Training Programmes - Show More Button Click'
            "
            ga-track="track"
            class="tw-bg-white tw-border tw-border-[#024B3F] tw-text-[#024B3F] tw-text-[16px] tw-font-medium tw-px-6 tw-py-2.5 tw-rounded-full tw-flex tw-items-center tw-gap-2 hover:tw-bg-[#024B3F] hover:tw-text-white transition"
            (click)="showMore()"
        >
            Show more
            <!-- Down Arrow Icon -->
            <svg
                xmlns="http://www.w3.org/2000/svg"
                class="tw-w-4 tw-h-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M19 9l-7 7-7-7"
                />
            </svg>
        </button>
    </div>
</div>
